import React from 'react';
import styles from './AsideAlert.scss';

export default function AsideAlert(props) {
  return (
    <div className={styles.AsideAlert}>
      <i
        className={`fa fa-exclamation-circle ${styles.asideAlertIcon}`}
        aria-hidden="true"
      />
      {' '}
      {props.children}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/ModerationCard/AsideAlert.js